import styled from "styled-components";

export const ExternalWrapper = styled.div<any>`
`;
